import ready from '../parent/js/lib/ready';
import promiseIdle from '../parent/js/lib/promise-idle';

import Splide from '@splidejs/splide';
import {trigger} from "../parent/js/lib/events";

// noinspection JSUnresolvedReference
Splide.defaults = {
    i18n: window.slider_i18n || {},
    mediaQuery: 'min',
};

ready().then(function init() {
    reload() && document.addEventListener('reload', reload);
});

function reload() {
    return Promise.resolve().then(promiseIdle()).then(function () {
        document.querySelectorAll('.splide').forEach(element => {
            const splide = new Splide(element);
            
            const options = {
                arrows: splide.options.arrows,
                pagination: splide.options.pagination,
                drag: splide.options.drag,
            };

            // https://splidejs.com/guides/overflow/#loop-carousel
            splide.on('overflow', function (isOverflow) {
                // Reset the carousel position
                splide.go(0);
                splide.options = {
                    arrows: isOverflow && options.arrows,
                    pagination: isOverflow && options.pagination,
                    drag: isOverflow && options.drag,
                    clones: isOverflow ? undefined : 0, // Toggle clones
                };
            });

            splide.on('ready', function () {
                trigger.call(element, 'splide/current', splide.index);
            });

            splide.on('move', function (index) {
                trigger.call(element, 'splide/current', index);
            });

            if (element.offsetParent) {
                splide.mount();
                return;
            }

            let node = element;
            while (node.offsetParent === null) {
                node = node.parentNode;
            }
            const observer = new MutationObserver(function () {
                if (element.offsetParent) {
                    splide.mount();
                    observer.disconnect();
                }
            });
            observer.observe(node, {attributes: true, subtree: true});
        });
    });
}
